"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlatTypes = void 0;
var FlatTypes;
(function (FlatTypes) {
    FlatTypes["Apartment"] = "apartment";
    FlatTypes["Local"] = "local";
    FlatTypes["House"] = "house";
})(FlatTypes = exports.FlatTypes || (exports.FlatTypes = {}));
//# sourceMappingURL=Feature.types.js.map